import { render, staticRenderFns } from "./region.vue?vue&type=template&id=0d466942&scoped=true"
import script from "./region.vue?vue&type=script&lang=js"
export * from "./region.vue?vue&type=script&lang=js"
import style0 from "./region.vue?vue&type=style&index=0&id=0d466942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d466942",
  null
  
)

export default component.exports